import { computed, ref } from 'vue';
import i18n from '@/i18n/index';

export const createRedirectDomainsModule = () => {
  const redirectDomains = ref({
    data: [] as TrackingDomain[],
    isUploaded: false,
  });

  const populateRedirectDomainsCache = (payload: TrackingDomain[]) => {
    redirectDomains.value.data = payload;
    redirectDomains.value.isUploaded = true;
  };

  const resetRedirectDomains = () => {
    redirectDomains.value.data = [];
    redirectDomains.value.isUploaded = false;
  };

  const redirectDomainsWithAccountDefault = computed((): TrackingDomain[] => [
    {
      campaignId: '',
      campaignNameFull: '',
      custom: false,
      domain: String(i18n.global.t('Account default')),
      httpsAvailable: false,
      id: '',
      userId: '',
      workspaceIds: [],
    } as TrackingDomain,
    ...redirectDomains.value.data,
  ]);

  const reset = () => {
    resetRedirectDomains();
  };

  return {
    state: {
      redirectDomains,
      populateRedirectDomainsCache,
      resetRedirectDomains,
      redirectDomainsWithAccountDefault,
    },
    reset,
  };
};
